import React from "react";
import {trendingFormatter} from "../../util/trendingFormatter";
import FireSvg from "../../util/svg/FireSvg";
import MedalSvg from "../../util/svg/share/MedalSvg";

const Badge = ({type, index, label, scale}) => {

    return <div className="image-order-container">
        {type === 'top' && (
            index < 3 ? (
                <div style={{transform: `scale(${scale})`}} className={'badge'}>
                    <img
                        src="/images/position/trophy.png"
                        alt="Order badge"
                        width={40}
                    />
                    <span className="trophy-number">
                                    {index + 1}
                                </span>
                </div>
            ) : (
                <div className={'badge'}>
                    <MedalSvg size={'40px'}/>
                    <div className={`medal-text ${index > 8 ? 'two-digits' : ''}`}>
                        {index + 1}
                    </div>
                </div>
            )
        )}
        {type === 'trending' && (
            <div style={{transform: `scale(${scale})`}} className="fire-container">
                <div className={'badge'}>
                    <div className="fire-text">
                        {trendingFormatter(label)}
                    </div>
                    <div style={{transform: 'scale(1.6)'}}>
                        <FireSvg width={'40px'}/>
                    </div>
                </div>
            </div>
        )}
    </div>
}

export default Badge;
